import apiService from "../../api/api.service";
import { CouponsResponse, CouponProductsResponse } from "./coupon.types";
import { FilterRequest } from "../filters/filters.types";

export const fetchCoupons = () => {
  return apiService.get<CouponsResponse>("/cart/coupons");
};

export const fetchCouponProducts = (
  idOrCode: number | string,
  page: number = 1,
  filters?: Partial<FilterRequest>,
) => {
  const { section_id, seque, ...rest } = filters ?? {};
  const filtersClean = Object.fromEntries(
    Object.entries(rest).filter(([, v]) => v !== undefined),
  );
  return apiService.get<CouponProductsResponse>(
    `/cart/coupons/${idOrCode}/products`,
    {
      params: {
        page,
        ...(section_id !== undefined ? { section_id } : {}),
        ...(seque !== undefined ? { seque } : {}),
        ...(Object.keys(filtersClean).length ? { filters: filtersClean } : {}),
      },
    },
  );
};